module.exports = __webpack_public_path__ + "static/img/what3.96ee6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/what3.png
// module id = Mwlu
// module chunks = 0